import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Sparkles, ArrowLeft } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startGoogleAuth = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    api.get("/auth/me")
      .then(() => navigate("/admin"))
      .catch(() => {})
      .finally(() => setChecking(false));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAF9] grain-bg flex flex-col">
      <div className="container-x py-6">
        <Link to="/" data-testid="login-back" className="inline-flex items-center gap-2 text-sm font-semibold text-[#064E3B] hover:text-[#C2410C]">
          <ArrowLeft className="h-4 w-4"/> Back to site
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md bg-white border border-[#E7E5E4] rounded-3xl p-10 shadow-xl">
          <div className="h-12 w-12 rounded-xl bg-[#064E3B] flex items-center justify-center">
            <Sparkles className="h-6 w-6 text-[#F59E0B]" />
          </div>
          <h1 className="font-display mt-6 text-3xl font-black text-[#064E3B] tracking-tight">
            Admin sign in
          </h1>
          <p className="mt-2 text-sm text-[#57534E]">
            Only 5GB Corporation team members can access the lead dashboard.
          </p>

          <button
            onClick={startGoogleAuth}
            disabled={checking}
            data-testid="login-google-btn"
            className="mt-8 w-full h-12 rounded-full bg-[#064E3B] text-white font-bold flex items-center justify-center gap-3 hover:bg-[#042F2E] transition-colors disabled:opacity-60"
          >
            <GoogleIcon /> Continue with Google
          </button>

          <p className="mt-6 text-xs text-[#78716C] text-center">
            Secure session cookie · 7-day auto-login
          </p>
        </div>
      </div>
    </div>
  );
}

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35.5 24 35.5c-6.4 0-11.5-5.1-11.5-11.5S17.6 12.5 24 12.5c3 0 5.7 1.1 7.8 3l5.7-5.7C33.8 6.4 29.1 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5c10.9 0 19.5-8.6 19.5-19.5 0-1.2-.1-2.3-.3-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.9 19 12.5 24 12.5c3 0 5.7 1.1 7.8 3l5.7-5.7C33.8 6.4 29.1 4.5 24 4.5c-7.4 0-13.7 4.1-17.2 10.2z"/>
    <path fill="#4CAF50" d="M24 43.5c5 0 9.6-1.9 13.1-5l-6.1-5c-2 1.5-4.5 2.4-7 2.4-5.2 0-9.6-3.1-11.3-7.5l-6.5 5c3.4 6.2 9.7 10.1 17.8 10.1z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.4-2.3 4.4-4.2 5.9l6.1 5c-.4.4 6.8-5 6.8-14.9 0-1.2-.1-2.3-.4-3.5z"/>
  </svg>
);
